export const platformSuppliersKeys = {
  platformSuppliers: (searchTerm: string) => ['content-management', 'platform-suppliers', searchTerm],
};
